import * as actionTypes from './actionTypes';

const initialState = {
  loading: true,
  features: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.getCompanyFeaturesInit:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.getCompanyFeaturesSuccess:
      return {
        ...state,
        loading: false,
        features: action.features,
      };
    case actionTypes.getCompanyFeaturesError:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}
